import {
  createWebHistory,
  createRouter,
  type Router,
  type RouteRecordRaw,
} from "vue-router";
import { isDevelopmentDeployment } from "@saflib/vue";
import { SentEmailsAsync } from "@saflib/email-vue";
import { LastMockEmailPageAsync } from "@saflib/email-vue";
import { CronJobsPage } from "@saflib/cron-vue";
import { ProductEventsAsync } from "@saflib/analytics-vue";
import { MetricsAsync } from "@saflib/node-metrics-vue";
import { ErrorsAsync } from "@saflib/errors-vue";
import { DevLogsPage } from "@saflib/node-log-vue";
import { PageNotFound } from "@saflib/vue/components";
import TestUtilsPage from "./pages/test-utils/TestUtilsPage.vue";
import { adminLinks } from "@vendata/power-up-links";

// BEGIN WORKFLOW AREA page-imports FOR vue/add-view
import DashboardAsync from "./pages/dashboard/DashboardAsync.vue";
import TransactionsAsync from "./pages/transactions/TransactionsAsync.vue";
import TransactionDetailAsync from "./pages/transaction-detail/TransactionDetailAsync.vue";
import RepairsAsync from "./pages/repairs/RepairsAsync.vue";
import RepairDetailAsync from "./pages/repair-detail/RepairDetailAsync.vue";
// END WORKFLOW AREA

let adminRouterInstance: Router | undefined;

interface AdminRouterOptions {
  additionalRoutes?: RouteRecordRaw[];
  testUtilsPath?: string;
  mockEmailsPath?: string;
  cronJobsPath?: string;
  cronJobsSubdomain?: string;
}

const devObservabilityRoutes: RouteRecordRaw[] = isDevelopmentDeployment()
  ? [
      {
        path: adminLinks.errors.path,
        component: ErrorsAsync,
      },
      {
        path: adminLinks.emails.path,
        component: SentEmailsAsync,
      },
      {
        path: adminLinks.logs.path,
        component: DevLogsPage,
      },
      {
        path: adminLinks.metrics.path,
        component: MetricsAsync,
      },
      {
        path: adminLinks.events.path,
        component: ProductEventsAsync,
      },
    ]
  : [];

export const createAdminRouter = (options: AdminRouterOptions = {}) => {
  if (adminRouterInstance) {
    return adminRouterInstance;
  }
  const routes: RouteRecordRaw[] = [
    ...(options?.additionalRoutes ?? []),
    {
      path: adminLinks.home.path,
      component: DashboardAsync,
    },
    {
      path: options?.testUtilsPath || adminLinks.testUtils.path,
      component: TestUtilsPage,
    },
    {
      path: options?.mockEmailsPath || adminLinks.mockEmailsLast.path,
      component: LastMockEmailPageAsync,
      name: "LastMockEmail",
    },
    {
      path: options?.cronJobsPath || adminLinks.cronJobs.path,
      component: CronJobsPage,
      name: "Cron Jobs",
      props: {
        subdomain: options?.cronJobsSubdomain,
      },
    },
    ...devObservabilityRoutes,
    // BEGIN WORKFLOW AREA page-routes FOR vue/add-view
    {
      path: adminLinks.dashboard.path,
      component: DashboardAsync,
    },
    {
      path: adminLinks.transactions.path,
      component: TransactionsAsync,
    },
    {
      path: adminLinks.transactionDetail.path,
      component: TransactionDetailAsync,
    },
    {
      path: adminLinks.repairs.path,
      component: RepairsAsync,
    },
    {
      path: adminLinks.repairDetail.path,
      component: RepairDetailAsync,
    },
    // END WORKFLOW AREA
    { path: "/:pathMatch(.*)*", component: PageNotFound },
  ];

  adminRouterInstance = createRouter({
    history: createWebHistory(),
    routes,
  });
  return adminRouterInstance;
};

export const router = createAdminRouter({
  cronJobsSubdomain: "power-up",
});
